<template>
  <div style="padding: 24px;">
    <el-result icon="warning" title="页面未找到" sub-title="组件未注册或文件缺失">
      <template slot="extra">
        <el-button type="primary" @click="$router.push('/index')">返回首页</el-button>
      </template>
    </el-result>
  </div>
</template>

<script>
export default { name: 'NotFound' }
</script>

<style scoped>
</style>